<template>
  <div class="popup-back" :style="`display: ${isShow ? 'block' : 'none'};`">
    <section class="popup ticket-intro-layer">
      <h1 class="popup-title" tabindex="1">Wavve 이용권 소개 팝업</h1>
      <div class="popup-button-close">
        <button @click.prevent="closeFn">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAP9JREFUSA3tlUsKwjAQhou3cyWuu2t3vYDgAXovPUi7EbyDCvULdEoZzYsmG83AT/qYf75kQkhVlSgd+JsOTNN0QFdUxy4azx5dUBvrrTAZqEQXWgDDET1m4xjqW/Iw1rNZBi+cxDXU+E5LwZgHjJ1xr8IKJ0dD+xjWRy4FvfDkUJmFC54N6oJnhzrgT+AS2/ZUILYRit5zA46G7mwAx/c7/17q/029p31lZfrImNVKWI/apllQXUN7vum2p4V/g8oqssFd0GzwEGhyOFBztcktw6P/yJCj97yRiQWPFDH3qUTwOcWwhg/BQEmkQItGFH214WnQgM5Sr4ylA7/fgTe/2zTk30iqjgAAAABJRU5ErkJggg==" alt="팝업 닫기">
        </button>
      </div>
      <div>
        <h2>Wavve 이용권 소개</h2>
        <div>
          <table>
            <caption>Wavve 이용권 소개표</caption>
            <colgroup>
              <col style="width: 25%;">
              <col style="width: 25%;">
              <col style="width: 25%;">
              <col style="width: 25%;">
            </colgroup>
            <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Basic</th>
              <th scope="col">Standard</th>
              <th scope="col">Premium</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th scope="row">매월 자동결제요금</th>
              <td>7,900원</td>
              <td>10,900원</td>
              <td>13,900원</td>
            </tr>
            <tr>
              <th scope="row">시청 가능 콘텐츠</th>
              <td colspan="3">
                <span>방송+LIVE+해외 시리즈 시청 (타임머신, QVOD 포함)</span>
                <span>&plus;</span>
                <span>Wavvie 영화 시청</span>
              </td>
            </tr>
            <tr>
              <th scope="row">시청 가능 화질</th>
              <td>HD</td>
              <td>FHD</td>
              <td>FHD 이상</td>
            </tr>
            <tr>
              <th scope="row">동시시청가능</th>
              <td>1대</td>
              <td>2대</td>
              <td>4대</td>
            </tr>
            <tr>
              <th scope="row">시청 가능 기기</th>
              <td>모바일&plus;PC</td>
              <td colspan="2">전체 디바이스</td>
            </tr>
            <tr>
              <th scope="row">개별구매 영화 시청</th>
              <td colspan="3">별도 개별 구매</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
  <!-- /이용권 소개 팝업-->
</template>

<script>
export default {
  name: 'VoucherInfoPopup.vue',
  props: {
    isShow: {
      type: Boolean
    },
    closeFn: {
      type: Function
    }
  }
}
</script>
